<template>
  <article
    class="content-container chart2-container"
    style="position: relative"
  >
    <ArticleTitle
      class="content-mg"
      :explainTitle="$t('menu.kibotChart')"
      :mainTitle="$t('strategy.menu.doubleList')"
    />

    <section class="chart kibot-chart__list-wrapper">
      <Draggable
        ref="draggableRef"
        :list="accordionList"
        :disabled="!enabled"
        item-key="name"
        class="list-group"
        ghost-class="ghost"
        :move="checkMove"
        @start="dragging = true"
        @end="dragging = false"
        handle=".handle"
      >
        <template #item="{ element }">
          <UiAccordion
            ref="accordionRef"
            :title="$t(element.title)"
            :tooltipMsg="element.tooltipMsg"
            :icon="element.icon"
            :iconStyle="element.iconStyle"
            :data-key="element.key"
            :viewPage="element.viewPage"
            :accordionList="accordionList"
            :isOpen="element.open"
            :class="{ active: element.open }"
            :badge="element.key === 'strategy' ? 'New' : false"
          >
            <section v-if="element.open" v-html="element.content"></section>

            <lazyStrategy
              v-if="element.open && element.key === 'strategy'"
              :isDashBoard="false"
              size="big"
              currentStrategy="double"
            ></lazyStrategy>

            <div
              class="coinlist-grid-container"
              :class="locale"
              ref="coinListRef"
              style="position: relative"
              v-if="element.open && element.key === 'coinList'"
            >
              <lazyTablesCoinList
                @onRendered="handleTableMounted"
                @openPopup="openPopup(element.viewPage)"
                currentStrategy="double"
              />
            </div>
          </UiAccordion>
        </template>
      </Draggable>
    </section>
    <AlertMsg v-show="alertMsg.visible" />
  </article>
</template>

<script setup>
import Draggable from "vuedraggable"; // vue3-draggable 대신 vuedraggable을 사용
import ArticleTitle from "@/components/ui/ArticleTitle.vue";
import UiAccordion from "@/components/ui/Accordion.vue";
import {
  ref,
  defineAsyncComponent,
  onMounted,
  watch,
  computed,
  onUnmounted,
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

const lazyStrategy = defineAsyncComponent(() =>
  import("@/components/dashboard/StrategyChart.vue")
);
const lazyTablesCoinList = defineAsyncComponent(() =>
  import("@/components/tables/coinList/CoinList.vue")
);
import strategy_ico from "@/assets/images/icons/chart/dark/strategy_chart_ico.svg";
import AlertMsg from "@/components/bot/AlertMsg.vue";
import chart_coinlist from "@/components/explanation/chart_coinlist_double.vue";

const accordionRef = ref(null);

const openPopup = (viewPage) => {
  if (accordionRef.value) {
    accordionRef.value.showPopup(viewPage);
  }
};

const store = useStore();
const alertMsg = computed(() => store.state.usePopupList.alertMsg);
const route = useRoute();
const { t, locale } = useI18n({ useScope: "global" });
// const router          = useCustomRouter();
const draggableRef = ref(null);
const coinListRef = ref(null);
const enabled = ref(true);
const dragging = ref(false);
// const userStore       = useUserStore();
// const chartSubScribe  = userStore.getChartSubscribeInfo();
const sectionTitle = ref({
  kibotChart: {
    main: "menu.kibotChart",
    sub: "Rising X",
  },
});
let userInfo = computed(() => store.state.userInfo.risingUserInfo);
let chartSubScribeInfo = computed(() => store.state.userInfo.chartInfo);
// const afterChartAuth = chartSubScribe.subsc_type == 'plan99' ? false : true;
const renderRef = ref({
  dominance: false,
  bubble: false,
});
function renderHandler(key) {
  renderRef.value[key] = true;
  const renderStatus = Object.values(renderRef.value);
  if (renderStatus.every((ob) => ob)) {
    scrollHandler(route.query.menuName);
  }
}
watch(userInfo, async (newVal) => {
  // console.log("newVal", newVal);
  if (userInfo.value) {
    if (Object.keys(userInfo.value).length != 0) {
      if (userInfo.value.chart_subsc_wht == "N") {
        openAlertMsg("chartPurmission");
        return;
      }
      await store.dispatch("getCoinList/fetchCoin");
    } else {
      openAlertMsg(422);
      return;
    }
  } else {
    openAlertMsg(422);
    return;
  }
});
let accordionList = ref([]);
onMounted(async () => {
  // console.log("userInfo", userInfo.value);
  if (userInfo.value) {
    if (Object.keys(userInfo.value).length != 0) {
      if (userInfo.value.chart_subsc_wht == "N") {
        openAlertMsg("chartPurmission");
        return;
      }
      await store.dispatch("getCoinList/fetchCoin");
    } else {
      openAlertMsg(422);
      return;
    }
  }
  requestAnimationFrame(() => {
    accordionList.value = [
      {
        key: "strategy",
        title: "Strategy Chart",
        content: "<div></div>",
        // tooltipMsg: `Dominance description`,
        icon: strategy_ico,
        iconStyle: {
          width: "25px",
        },
        open: true,
        // viewPage: chart_afterevent,
      },
    ];
    accordionList.value.push({
      key: "coinList",
      title: "menu-dropdown.coinList",
      content: "<div></div>",
      tooltipMsg: `Coin List`,
      // icon: after_ico,
      // iconStyle: {
      //   width: "20px",
      // },
      open: true,
      viewPage: chart_coinlist,
    });
    if (
      chartSubScribeInfo.value &&
      chartSubScribeInfo.value.subsc_type != "plan99"
    ) {
    }
  });
});
onUnmounted(() => {
  store.commit("usePopupList/toggleAlertMsg", { visible: false });
});
const checkMove = async (e) => {};

watch(
  () => route.query.menuName,
  (newVal) => {
    scrollHandler(newVal);
  }
);

function scrollHandler(type) {
  if (alertMsg.value.visible) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    switch (type) {
      case "coin_list":
        if (coinListRef.value) {
          const top =
            coinListRef.value.getBoundingClientRect().top +
            window.scrollY -
            109;
          window.scrollTo({ top: top, behavior: "smooth" });
        }
        break;
      default:
        if (draggableRef.value) {
          const fi = draggableRef.value.list.findIndex((ob) => ob.key === type);
          const $dom = draggableRef.value.$el.children[fi];

          if ($dom) {
            const top =
              draggableRef.value.$el.children[fi].getBoundingClientRect().top +
              window.scrollY -
              114;
            window.scrollTo({ top, behavior: "smooth" });
          }
        }
        break;
    }
  }
}

function handleTableMounted() {
  scrollHandler(route.query.menuName);
}

function openAlertMsg(code) {
  store.commit("usePopupList/toggleAlertMsg", { visible: true, code: code });
}
</script>

<style scoped>
@import "@/assets/scss/pages/kibot/chart.scss";
</style>
